import React, { useEffect, useState, useRef } from 'react';
import { useOutletContext, useNavigate, useLocation } from 'react-router-dom';
import './Highlights.css';
import year2023 from '../../../assets/Images/Highlights/Folder20222023.webp';
import year2024 from '../../../assets/Images/Highlights/Folder20232024.webp';
import year2025 from '../../../assets/Images/Highlights/Folder20242025.webp';
import profileImage from '../../../assets/Images/Highlights/Profile.webp';
import LoadingSpinner from '../../../shared/components/LoadingSpinner/LoadingSpinner';
import { yearTwentyTwentyFourFive } from './HighlightsDirectory/HighlightImages/HL20242025';
import { yearTwentyTwentyThreeFour} from "./HighlightsDirectory/HighlightImages/HL20232024";
import { yearTwentyTwentyTwoThree } from "./HighlightsDirectory/HighlightImages/HL20222023";
import { NotificationManager } from 'react-notifications';


const Highlights = () => {
  const [pageLoading, setPageLoading] = useState(true);
  const { setContentLoaded = () => {} } = useOutletContext() || {};
  const navigate = useNavigate();
  const location = useLocation();
  const notifiedRef = useRef(false);

  const open20242025Link = () => {
    navigate('/Highlights/Memories', {
      state: {
        images: yearTwentyTwentyFourFive,
        year: '2024-2025'
      },
    });
  };

  const open20232024Link = () => {
    navigate('/Highlights/Memories', {
      state: {
        images: yearTwentyTwentyThreeFour,
        year: '2023-2024'
      },
    });
  };

  const open20222023Link = () => {
    navigate('/Highlights/Memories', {
      state: {
        images: yearTwentyTwentyTwoThree,
        year: '2022-2023'
      }
    })
  }

  useEffect(() => {
    if (!pageLoading && location.state && location.state.notification && !notifiedRef.current) {
      notifiedRef.current = true;
      NotificationManager.info(location.state.notification, 'Info', 5000);
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [pageLoading, location, navigate]);

  useEffect(() => {
    const t = setTimeout(() => {
      setPageLoading(false);
      setContentLoaded(true);
    }, 500);
    return () => clearTimeout(t);
  }, [setContentLoaded]);

  if (pageLoading) {
    return (
      <div style={{ margin: 'auto' }}>
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <div className="highlightsPage">
      <p className="highlightsLabel">
        <span className="hpLabel">✨Language Department Highlights ✨</span>
      </p>

      <div className="highlightsContainer">
        <div>
          <h2 className="schoolYearLabel year20242025">SCHOOL YEAR</h2>
          <img
            className="folderYearLabels"
            src={year2025}
            alt="Year 2025"
            width="30%"
            onClick={open20242025Link}
            style={{ cursor: 'pointer' }}
          />
        </div>

        <div>
          <h2 className="schoolYearLabel year20232024">SCHOOL YEAR</h2>
          <img
            className="folderYearLabels"
            src={year2024}
            alt="Year 2024"
            width="30%"
            onClick={open20232024Link}
            style={{ cursor: 'pointer' }}
          />
        </div>

        <div>
          <h2 className="schoolYearLabel">SCHOOL YEAR</h2>
          <img
            className="folderYearLabels"
            src={year2023}
            alt="Year 2023"
            width="30%"
            onClick={open20222023Link}
            style={{ cursor: 'pointer' }}
          />
        </div>
      </div>

      <div className="mercyProfile">
        <img
          className="mercyValues"
          src={profileImage}
          alt="Mercy Profile"
          width="30%"
        />
      </div>
    </div>
  );
};

export default Highlights;
